const MAX_RANGE: number = 90; // Max selected days

export { MAX_RANGE };
